import { AgendaStore } from './schema/AgendaStore';
import { createStore } from 'satcheljs';
import '../orchestrators/loadAgendaViewOrchestrator';

export function createEmptyAgendaStore(): AgendaStore {
    return {
        items: [],
        dateAtTop: null,
        upcomingItemId: null,
        ongoingItemId: null,
        minutesRemainingForUpcomingItem: 0,
        upcomingEventStartTime: 0,
        isLoading: false,
    };
}

const agendaStoreData: AgendaStore = createEmptyAgendaStore();
const getAgendaStore = createStore<AgendaStore>('agendaStore', agendaStoreData);

export const agendaStore = getAgendaStore();

export default getAgendaStore;
